import { Stack } from '@fluentui/react';
import {
  FormHookAmount,
  FormHookDropdown,
  FormHookTextField,
} from 'common/components/FormHooksFields';
import { FormHookToggle } from 'common/components/FormHooksFields/FormHookToggle';
import { DEFAULT_FIELD_NAMES } from '../constant';

interface DynamicFieldProps {
  layoutType: string;
  name?: string;
  businessRuleSelectionOptions?: { key: string | number; text: string }[];
  isUpdatable: boolean;
}

const RenderField: React.FC<DynamicFieldProps> = ({
  layoutType,
  name,
  businessRuleSelectionOptions,
  isUpdatable,
}) => {
  const fieldName = name || DEFAULT_FIELD_NAMES[layoutType];

  if (!fieldName) return null;

  switch (layoutType) {
    case 'BR_BOOLEAN':
      return (
        <Stack style={{ width: 300 }}>
          <FormHookToggle
            name={fieldName}
            inlineLabel
            label="Selected"
            disabled={!isUpdatable}
          />
        </Stack>
      );
    case 'BR_AMOUNT':
    case 'BR_SMALLINT':
    case 'BR_NUMERIC':
      return (
        <FormHookAmount
          name={fieldName}
          width={300}
          placeholder="please enter a numeric value"
          disabled={!isUpdatable}
        />
      );
    case 'BR_DROP_DOWN':
      return (
        <FormHookDropdown
          name={fieldName}
          options={businessRuleSelectionOptions || []}
          width={300}
          disabled={!isUpdatable}
        />
      );
    case 'BR_TEXT':
      return (
        <FormHookTextField
          name={fieldName}
          width={300}
          placeholder="please enter text"
          disabled={!isUpdatable}
        />
      );
    default:
      return null;
  }
};

export default RenderField;
